import React, { useMemo } from 'react'
import { v4 as uuid } from 'uuid'

import { VIEWPORT_SIZE, className, drawStarPath } from './index'

const Template = React.memo(props => {
  const { strokeWidth = 8, fill = 'none', borderRadius = 10 } = props
  const outerMaskId = useMemo(uuid, [])
  const innerMaskId = useMemo(uuid, [])
  const paddingHorizontal = 18
  const paddingVertical = 4

  const cogwheelCenterX = paddingHorizontal + 8
  const cogwheelCenterY = VIEWPORT_SIZE - paddingHorizontal - 8
  const cogwheelRadius = 20
  const cogwheelHoleRadius = 13
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${VIEWPORT_SIZE} ${VIEWPORT_SIZE}`}
      preserveAspectRatio="none"
    >
      <defs>
        <mask id={outerMaskId}>
          <rect x="0" y="0" width={`${VIEWPORT_SIZE}`} height={`${VIEWPORT_SIZE}`} stroke="none" fill="white" />
          <circle cx={`${cogwheelCenterX}`} cy={`${cogwheelCenterY}`} r={`${cogwheelRadius + (strokeWidth * 2) / 3}`} stroke="none" fill="black" />
        </mask>
        <mask id={innerMaskId}>
          <rect x="0" y="0" width={`${VIEWPORT_SIZE}`} height={`${VIEWPORT_SIZE}`} stroke="none" fill="white" />
          <circle cx={`${cogwheelCenterX}`} cy={`${cogwheelCenterY}`} r={`${cogwheelHoleRadius / 2}`} stroke="none" fill="black" />
        </mask>
      </defs>
      <path
        d={`M ${paddingHorizontal + borderRadius} ${paddingVertical} H ${VIEWPORT_SIZE / 2} L ${VIEWPORT_SIZE - paddingHorizontal} ${
          VIEWPORT_SIZE / 2 - paddingHorizontal + paddingVertical
        } V ${VIEWPORT_SIZE - paddingVertical - borderRadius} q 0 ${borderRadius} ${-borderRadius} ${borderRadius} H ${
          paddingHorizontal + borderRadius
        } q ${-borderRadius} 0 ${-borderRadius} ${-borderRadius} V ${
          paddingVertical + borderRadius
        } q 0 ${-borderRadius} ${borderRadius} ${-borderRadius} Z`}
        stroke="currentColor"
        strokeWidth={`${strokeWidth}`}
        strokeLinejoin="round"
        fill={`${fill}`}
        mask={`url(#${outerMaskId})`}
      />
      <path
        d={`M ${VIEWPORT_SIZE / 2} ${paddingVertical} L ${VIEWPORT_SIZE - paddingHorizontal} ${
          VIEWPORT_SIZE / 2 - paddingHorizontal + paddingVertical
        } H ${VIEWPORT_SIZE / 2} Z`}
        stroke="currentColor"
        strokeWidth={`${(strokeWidth * 2) / 3}`}
        strokeLinejoin="round"
        fill={`${fill}`}
      />
      <path
        d={drawStarPath(cogwheelCenterX, cogwheelCenterY, 8, 10, 0, cogwheelRadius, cogwheelHoleRadius)}
        stroke="currentColor"
        strokeWidth={`${strokeWidth / 3}`}
        strokeLinejoin="round"
        fill="currentColor"
        mask={`url(#${innerMaskId})`}
      />
    </svg>
  )
})

export { Template }
export default Template
